import { InjectionToken } from "@angular/core";

export const CONFIG_URL = new InjectionToken<string>("configUrl");
